import { Amplify } from "aws-amplify";

type RegionType = "ap-southeast-2";

export interface CognitoSettings {
  region: RegionType;
  userPoolId: string;
  userPoolWebClientId: string;
}

export const AmplifyConfigure = () => {
  function config(cognitoSettings: CognitoSettings) {
    Amplify.configure({
      Auth: {
        region: cognitoSettings.region,
        userPoolId: cognitoSettings.userPoolId,
        userPoolWebClientId: cognitoSettings.userPoolWebClientId,
      },
    });
  }

  return {
    config,
  };
};

export const Environment = process.env.REACT_APP_ENV || "dev";
